/*
 * SurveyDialog.jsx 06.03.2018
 *
 * (c) 2018 ergovia GmbH
 */
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



// 60 (seconds) * 60 (minutes) * 1000 (milliseconds to seconds) * 4 (hours)
const REFRESH_INTERVAL_4_HOURS = 14400000;

/**
 * Die Komponente für den SurveyDialog.
 */
class SurveyDialog extends React.Component {

    componentDidMount() {

        setInterval(function getSurvey() {
            this.props.workTheSurvey();
            return getSurvey.bind(this);
        }.bind(this)(), REFRESH_INTERVAL_4_HOURS);
    }

    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={() => this.props.closeSurveyDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Helfen Sie uns, den Bildungsmanager weiter zu entwickeln!</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.props.description}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button id="button-nein" onClick={() => this.props.closeSurveyDialog()} color="default">
                            Nein
                        </Button>
                        <Button id="button-ja" onClick={() => {window.open(this.props.webLink);
                            this.props.closeSurveyDialog();}} color="primary" autoFocus>
                            Ja
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default SurveyDialog;



// WEBPACK FOOTER //
// ./src/de/ergovia/components/core/SurveyDialog.jsx